<template>
  <import-data-view type="shopEmployees" title="Стоматологи"></import-data-view>
</template>

<script>
    import ImportDataView from '@/components/import/ImportDataView';

    export default {
        components: {
            ImportDataView,
        },
    };
</script>


// WEBPACK FOOTER //
// src/pages/ui/ImportShopEmployees.vue